import Medication from "./Medication";
function Medications({ medications }) {
  return (
    <div className="shadow card mt-4">
      <div className="card-body">
        <h5 className="card-title">Medications</h5>
        {medications &&
          Object.keys(medications).map((med) => (
            <Medication key={med} name={med} dates={medications[med]} />
          ))}
      </div>
    </div>
  );
}
export default Medications;
